import { format } from 'util';

function escapeLiteral(value: string): string {
  return `'${value.replaceAll('\0', '').replaceAll("'", "''")}'`;
}

export function linkedToRecordTitles(formId: string, linkedRecordIds: string[]) {
  const escaped = linkedRecordIds.map(escapeLiteral);
  return format(
    `SELECT _record_id, _title FROM "${formId}" WHERE _record_id IN (%s)`,
    escaped,
  );
}

export function linkedFromRecordTitles(
  parentFormId: string, parentFieldName: string, childRecordIds: string[], repeatableKey?: string,
) {
  const escaped = childRecordIds.map(escapeLiteral);
  const quotedField = `"${parentFieldName.replaceAll('"', '""')}"`;
  if (repeatableKey) {
    // RecordLinkField lives in a repeatable sub-table ("{formId}/{repeatableKey}"),
    // but we need _title from the parent form table. JOIN to get both.
    const repeatableTable = `${parentFormId}/${repeatableKey}`;
    return format(`
    SELECT DISTINCT f._record_id as _parent_record_id, f._title, r.${quotedField} as _child_record_id FROM "${repeatableTable}" r
    JOIN "${parentFormId}" f ON r._record_id = f._record_id
    WHERE r.${quotedField} && ARRAY[%s]
  `, escaped);
  }
  return format(`
    SELECT _record_id as _parent_record_id, _title, ${quotedField} as _child_record_id FROM "${parentFormId}"
    WHERE ${quotedField} && ARRAY[%s]
  `, escaped);
}

// this will divide a large (+120) list of records into an array of sql statements.
export function chunkLinkedFromRecordTitles(
  parentFormId: string, parentFieldName: string, childRecordIds: string[], repeatableKey?: string,
):string[] {
  const chunkSize = 120;
  const chunkedChildRecordIds: string[][] = [];
  for (let i = 0; i < childRecordIds.length; i += chunkSize) {
    chunkedChildRecordIds.push(childRecordIds.slice(i, i + chunkSize));
  }
  // eslint-disable-next-line max-len
  return chunkedChildRecordIds.map((chunk) => linkedFromRecordTitles(parentFormId, parentFieldName, chunk, repeatableKey));
}
